import type { AnalyticsClient } from './types';

// ==============================|| ANALYTICS — NO-OP CLIENT ||============================== //
// Used when no PostHog key is configured (local dev, tests). Every method is a
// safe no-op so call sites never need to guard for "analytics off".

export const noopAnalyticsClient: AnalyticsClient = {
  init() {},
  isReady() {
    return false;
  },
  capture() {},
  identify() {},
  setPersonProperties() {},
  reset() {},
  onFeatureFlags() {},
  getFeatureFlag() {
    return undefined;
  },
  reloadFeatureFlags() {},
  surveyShown() {},
  surveyDismissed() {},
  surveySent() {}
};
